import { render, staticRenderFns } from "./CSRActivitiesCMS.vue?vue&type=template&id=8b1b18bc&scoped=true"
import script from "./CSRActivitiesCMS.vue?vue&type=script&lang=js"
export * from "./CSRActivitiesCMS.vue?vue&type=script&lang=js"
import style0 from "./CSRActivitiesCMS.vue?vue&type=style&index=0&id=8b1b18bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1b18bc",
  null
  
)

export default component.exports